// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function NpsGradientScaleWithSmileyForm$NpsItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  return JsxRuntime.jsx("button", {
              className: props.className,
              style: props.style,
              onClick: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSelection, step);
                })
            });
}

var NpsItem = {
  make: NpsGradientScaleWithSmileyForm$NpsItem
};

function NpsGradientScaleWithSmileyForm(props) {
  var contentOnly = props.contentOnly;
  var overrideQuestionBlock = props.overrideQuestionBlock;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var nps = props.nps;
  var scale = Nps$ReactHooksTemplate.scale(nps);
  var includeZero = Nps$ReactHooksTemplate.includeZero(nps);
  var selectedRating = Nps$ReactHooksTemplate.rating(nps);
  var steps = function (count, offset) {
    return Belt_List.makeBy(count, (function (x) {
                  return x + offset | 0;
                }));
  };
  var stepsCount;
  stepsCount = scale === "FiveScale" ? (
      includeZero ? 6 : 5
    ) : (
      includeZero ? 11 : 10
    );
  var startRating = includeZero ? 0 : 1;
  var endRating;
  endRating = scale === "FiveScale" ? 5 : 10;
  var likelyness;
  if (scale === "FiveScale") {
    if (selectedRating !== undefined) {
      switch (selectedRating) {
        case 0 :
        case 1 :
            likelyness = {
              TAG: "VeryUnlikely",
              _0: selectedRating
            };
            break;
        case 2 :
            likelyness = includeZero ? ({
                  TAG: "Unlikely",
                  _0: selectedRating
                }) : ({
                  TAG: "VeryUnlikely",
                  _0: selectedRating
                });
            break;
        case 3 :
            likelyness = {
              TAG: "Unlikely",
              _0: selectedRating
            };
            break;
        case 4 :
            likelyness = {
              TAG: "Maybe",
              _0: selectedRating
            };
            break;
        case 5 :
            likelyness = {
              TAG: "ExtremelyLikely",
              _0: selectedRating
            };
            break;
        default:
          likelyness = undefined;
      }
    } else {
      likelyness = undefined;
    }
  } else if (selectedRating !== undefined) {
    switch (selectedRating) {
      case 0 :
      case 1 :
          likelyness = {
            TAG: "VeryUnlikely",
            _0: selectedRating
          };
          break;
      case 2 :
      case 3 :
      case 4 :
      case 5 :
      case 6 :
          likelyness = {
            TAG: "Unlikely",
            _0: selectedRating
          };
          break;
      case 7 :
      case 8 :
          likelyness = {
            TAG: "Maybe",
            _0: selectedRating
          };
          break;
      case 9 :
          likelyness = {
            TAG: "Likely",
            _0: selectedRating
          };
          break;
      case 10 :
          likelyness = {
            TAG: "ExtremelyLikely",
            _0: selectedRating
          };
          break;
      default:
        likelyness = undefined;
    }
  } else {
    likelyness = undefined;
  }
  var filledBackgroundCSS;
  if (likelyness !== undefined) {
    switch (likelyness.TAG) {
      case "VeryUnlikely" :
          filledBackgroundCSS = "very-unlikely";
          break;
      case "Unlikely" :
          filledBackgroundCSS = "unlikely";
          break;
      case "Maybe" :
          filledBackgroundCSS = "maybe";
          break;
      case "Likely" :
          filledBackgroundCSS = "likely";
          break;
      case "ExtremelyLikely" :
          filledBackgroundCSS = "extremely-likely";
          break;
      
    }
  } else {
    filledBackgroundCSS = "";
  }
  var ratingEmoji;
  if (likelyness !== undefined) {
    switch (likelyness.TAG) {
      case "VeryUnlikely" :
          ratingEmoji = Image$ReactHooksTemplate.veryUnlikelySmiley;
          break;
      case "Unlikely" :
          ratingEmoji = Image$ReactHooksTemplate.unlikelySmiley;
          break;
      case "Maybe" :
          ratingEmoji = Image$ReactHooksTemplate.maybeSmiley;
          break;
      case "Likely" :
          ratingEmoji = Image$ReactHooksTemplate.likelySmiley;
          break;
      case "ExtremelyLikely" :
          ratingEmoji = Image$ReactHooksTemplate.extremelyLikelySmiley;
          break;
      
    }
  } else {
    ratingEmoji = "";
  }
  var ratingMessage;
  if (likelyness !== undefined) {
    switch (likelyness.TAG) {
      case "VeryUnlikely" :
          ratingMessage = Nps$ReactHooksTemplate.getVeryUnlikelyTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language));
          break;
      case "Unlikely" :
          ratingMessage = Nps$ReactHooksTemplate.getUnlikelyTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language));
          break;
      case "Maybe" :
          ratingMessage = Nps$ReactHooksTemplate.getMaybeTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language));
          break;
      case "Likely" :
          ratingMessage = Nps$ReactHooksTemplate.getLikelyTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language));
          break;
      case "ExtremelyLikely" :
          ratingMessage = Nps$ReactHooksTemplate.getExtremelyLikelyTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language));
          break;
      
    }
  } else {
    ratingMessage = "";
  }
  var rmName = CustomerInfo$ReactHooksTemplate.rmName(props.customerInfo);
  var questionText = Nps$ReactHooksTemplate.getTextTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", rmName);
  var count;
  count = scale === "FiveScale" ? (
      includeZero ? 6 : 5
    ) : (
      includeZero ? 11 : 10
    );
  var ratings = $$Array.of_list(Belt_List.mapWithIndex(steps(count, includeZero ? 0 : 1), (function (param, i) {
              return JsxRuntime.jsx("p", {
                          children: String(i)
                        });
            })));
  var items = function (a, b) {
    var count = (b - a | 0) + 1 | 0;
    return $$Array.of_list(Belt_List.map(steps(count, a), (function (x) {
                      return JsxRuntime.jsx(NpsGradientScaleWithSmileyForm$NpsItem, {
                                  step: x,
                                  className: "w-full",
                                  onSelection: (function (y) {
                                      Curry._1(onChange, Nps$ReactHooksTemplate.setAnswer(nps, y));
                                    }),
                                  style: {}
                                }, String(x));
                    })));
  };
  var questionBlock = overrideQuestionBlock !== undefined ? Caml_option.valFromOption(overrideQuestionBlock) : JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
          text: questionText,
          description: Nps$ReactHooksTemplate.getDescriptionTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)),
          mandatory: mandatory,
          surveyTheme: props.surveyTheme,
          substitutionVariables: props.substitutionVariables
        });
  var tmp;
  if (likelyness !== undefined) {
    var tmp$1;
    if (likelyness.TAG === "ExtremelyLikely") {
      tmp$1 = JsxRuntime.jsx("div", {
            children: items(startRating, endRating),
            className: " flex justify-between divide-x w-full\n                  " + filledBackgroundCSS + " h-78-px small:h-48-px rounded-lg\n                    divide-tropicalbreeze mb-16-px small:mb-8-px"
          });
    } else {
      var rating = likelyness._0;
      var filledCount = String(includeZero ? rating + 1 | 0 : rating);
      var unFilledCount = String(stepsCount - (
            includeZero ? rating + 1 | 0 : rating
          ) | 0);
      tmp$1 = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                    children: items(startRating, rating),
                    className: " flex justify-between divide-x\n                      w-" + filledCount + "/" + String(stepsCount) + "\n                        h-78-px small:h-48-px rounded-lg rounded-r-none\n                          divide-tropicalbreeze " + filledBackgroundCSS
                  }),
              JsxRuntime.jsx("div", {
                    children: items(rating + 1 | 0, endRating),
                    className: " flex justify-between divide-x\n                      w-" + unFilledCount + "/" + String(stepsCount) + "\n                        bg-tropicalbreeze h-78-px small:h-48-px rounded-lg\n                          rounded-l-none divide-herringsilver"
                  })
            ],
            className: "flex w-full mb-17-px small:mb-4-px bg-tropicalbreeze rounded-lg"
          });
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            tmp$1,
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("img", {
                          className: "mx-auto w-200-px small:w-160-px h-200-px\n                  small:h-160-px mb-8-px",
                          src: ratingEmoji
                        }),
                    JsxRuntime.jsx("p", {
                          children: ratingMessage,
                          className: "font-normal font-semibold text-2xl small:text-xl leading-8\n                  small:leading-4 text-center tracking-wide"
                        })
                  ],
                  className: "w-full flex flex-col items-center"
                })
          ]
        });
  } else {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
                  children: items(startRating, endRating),
                  className: "flex justify-between divide-x w-full\n                bg-tropicalbreeze h-78-px small:h-48-px rounded-lg divide-herringsilver\n                  mb-17-px small:mb-4-px"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: JsxRuntime.jsx("img", {
                                        className: "w-60-px h-60-px",
                                        src: Image$ReactHooksTemplate.sadRedSmiley
                                      })
                                }),
                            JsxRuntime.jsx("p", {
                                  children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                })
                          ],
                          className: "flex flex-col text-center items-start"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: JsxRuntime.jsx("img", {
                                        className: "w-60-px h-60-px",
                                        src: Image$ReactHooksTemplate.happyGreenSmiley
                                      })
                                }),
                            JsxRuntime.jsx("p", {
                                  children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                })
                          ],
                          className: "flex flex-col text-center items-end"
                        })
                  ],
                  className: "flex justify-between w-full text-base small:text-sm font-semibold\n                leading-4 tracking-wide"
                }),
            mandatory && Caml_obj.notequal(contentOnly, true) ? JsxRuntime.jsxs("p", {
                    children: [
                      "* ",
                      JsxRuntime.jsx("span", {
                            children: "Request your response. This is a mandatory question",
                            className: "text-xs"
                          })
                    ],
                    className: " w-full pt-6 small:pt-3\n                  text-lg opacity-50"
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
          ]
        });
  }
  var innerContent = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: ratings,
                      className: "flex justify-between w-full font-semibold text-base\n            text-center tracking-wide font-normal mb-8-px small:mb-4-px"
                    }),
                tmp
              ],
              className: "flex flex-col justify-between items-start"
            }),
        className: "w-full pb-8 px-16 small:px-6"
      });
  if (contentOnly !== undefined && contentOnly) {
    return innerContent;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                questionBlock,
                innerContent
              ],
              className: props.borderCss
            });
}

var make = NpsGradientScaleWithSmileyForm;

exports.NpsItem = NpsItem;
exports.make = make;
/* react/jsx-runtime Not a pure module */
